import script from "./ClaseGratis.vue?vue&type=script&setup=true&lang=js"
export * from "./ClaseGratis.vue?vue&type=script&setup=true&lang=js"

import "./ClaseGratis.vue?vue&type=style&index=0&id=4542d4ed&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4542d4ed"]])

export default __exports__